import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "field has-addons" }
const _hoisted_4 = { class: "control has-icon-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-user-plus" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Calculating split...", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "columns" }
const _hoisted_12 = { class: "column" }
const _hoisted_13 = { class: "card p-5" }
const _hoisted_14 = { class: "card-title" }
const _hoisted_15 = { class: "is-flex is-justify-content-space-between" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddUser = _resolveComponent("AddUser")!
  const _component_Expenses = _resolveComponent("Expenses")!
  const _component_TotalAndSplit = _resolveComponent("TotalAndSplit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.userToEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "input is-info is-small",
                placeholder: "Lägg till person",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userToEdit.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.userToEdit.name]
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("a", {
                  class: "button is-info is-small",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSaveUser && _ctx.onSaveUser(...args)))
                }, _hoisted_6)
              ])
            ])
          ])
        ]))
      : (_ctx.calculating)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_AddUser, { onAddUser: _ctx.addUser }, null, 8, ["onAddUser"]),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: user.id
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("img", {
                            src: require(`@/assets/${user.avatar}`),
                            alt: "Avatar",
                            width: "30"
                          }, null, 8, _hoisted_16),
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.onUpdateUser(user))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(user.name), 1)
                          ], 8, _hoisted_17),
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.onDeleteUser(user))
                          }, _hoisted_20, 8, _hoisted_18)
                        ])
                      ]),
                      _createVNode(_component_Expenses, {
                        userId: user.id,
                        expenses: user.expenses,
                        onAddExpense: _ctx.addExpense,
                        onDeleteExpense: _ctx.deleteExpense
                      }, null, 8, ["userId", "expenses", "onAddExpense", "onDeleteExpense"])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])),
    _createVNode(_component_TotalAndSplit, {
      totalAmount: _ctx.totalAmount,
      onClick: _ctx.calculateSplit
    }, null, 8, ["totalAmount", "onClick"])
  ], 64))
}